/**
 * Field names shared by the forms and the server-side spam check.
 *
 * Client-safe on purpose: the form components need these names, and importing
 * them from `spam.server` would drag the database and crypto modules into the
 * browser bundle. Same split as `review-scale` and `review.server`.
 */

/**
 * A field no human fills. Named plausibly enough that a bot filling every input
 * takes the bait, but not a term browsers autofill — an autofilled honeypot
 * would reject real people, the one outcome worth avoiding here.
 */
export const HONEYPOT_FIELD = 'contact_reference';

/** Carries the signed render time, so the server can tell how long the form was open. */
export const FORM_TOKEN_FIELD = 'form_token';
